import { createContext, ReactNode, useCallback, useContext, useState } from 'react';

interface Props {
    children: ReactNode;
}

const StoredUrlContext = createContext<{
    urlParams: Record<string, string>;
    updateUrlParams: (url: string, search: string) => void;
}>({ urlParams: {}, updateUrlParams: () => {} });

export function StoredUrlProvider({ children }: Props) {
    const [urlParams, setUrlParams] = useState<Record<string, string>>({});

    const updateUrlParams = useCallback((url, search) => {
        setUrlParams((previousUrlParams) => ({
            ...previousUrlParams,
            [url]: search,
        }));
    }, []);

    return <StoredUrlContext.Provider value={{ urlParams, updateUrlParams }}>{children}</StoredUrlContext.Provider>;
}

export function useStoredUrlContext() {
    return useContext(StoredUrlContext);
}
